import React from 'react';
import { LineChart, Line, ResponsiveContainer } from 'recharts';
import { CHART_COLORS } from './charts/chartTheme';

/**
 * Sparkline — Tiny trend line (no axes, just the shape).
 * Used in report overview cards to show 6-point trend.
 */
export default function Sparkline({ data = [], dataKey = 'value', color = CHART_COLORS.primary, height = 32, width = 80 }) {
  if (!data || data.length < 2) return null;

  return (
    <div style={{ width, height }}>
      <ResponsiveContainer width="100%" height="100%">
        <LineChart data={data} margin={{ top: 2, right: 2, bottom: 2, left: 2 }}>
          <Line
            type="monotone"
            dataKey={dataKey}
            stroke={color}
            strokeWidth={1.5}
            dot={false}
            isAnimationActive={false}
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
}
